import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useFeatureGate } from "@/features/plan/hooks";
import type { FeatureGateKey } from "@/features/plan/types";

/**
 * Gates a route on the current organization's plan feature switches.
 *
 * The matching sidebar items are hidden by AppShell, but direct URL access
 * needs to enforce the same feature gates so bookmarked/manually-entered
 * routes do not bypass agency-managed client switches.
 */
export function FeatureGateRoute({
  gate,
  children,
  redirectTo = "/dashboard",
}: {
  gate: FeatureGateKey;
  children: ReactNode;
  redirectTo?: string;
}) {
  const { enabled, loading } = useFeatureGate(gate);

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <p className="text-sm text-slate-500">Loading…</p>
      </div>
    );
  }

  if (!enabled) {
    return <Navigate to={redirectTo} replace />;
  }

  return <>{children}</>;
}
